var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29342 4.39131C7.62958 4.82951 7.54687 5.45725 7.10868 5.79341C5.21426 7.24672 4 9.51835 4 12.0695C4 16.4421 7.5744 20 12 20C16.4256 20 20 16.4421 20 12.0695C20 9.58159 18.8453 7.35985 17.0312 5.9032C16.6006 5.55742 16.5318 4.928 16.8776 4.49736C17.2233 4.06672 17.8528 3.99792 18.2834 4.34371C20.5473 6.1615 22 8.9464 22 12.0695C22 17.5612 17.5155 22 12 22C6.48447 22 2 17.5612 2 12.0695C2 8.86666 3.52768 6.01986 5.89132 4.20657C6.32952 3.87041 6.95726 3.95312 7.29342 4.39131Z",
    fill: "#181A1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C12.5523 2 13 2.44772 13 3V8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8V3C11 2.44772 11.4477 2 12 2Z",
    fill: "#181A1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnOff);
export default __webpack_public_path__ + "static/media/onOff.e55495ae34042402074479088fa2bd2a.svg";
export { ForwardRef as ReactComponent };